// Lightweight Web Audio synth for game micro-sounds (no assets).
let ctx = null;
let muted = localStorage.getItem("snetch_sound") === "off";

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone(freq, dur = 0.08, type = "sine", gain = 0.04) {
  if (muted) return;
  const c = getCtx();
  if (!c) return;
  try {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = type;
    o.frequency.value = freq;
    o.connect(g);
    g.connect(c.destination);
    const t = c.currentTime;
    g.gain.setValueAtTime(gain, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.start(t);
    o.stop(t + dur);
  } catch (e) { console.warn("sfx unavailable:", e); }
}

export const sfx = {
  tick: () => tone(520, 0.045, "square", 0.015),
  tickTense: () => tone(780, 0.06, "square", 0.03),
  buy: () => { tone(440, 0.07, "sine", 0.05); setTimeout(() => tone(660, 0.09, "sine", 0.05), 55); },
  sell: () => { tone(440, 0.07, "sine", 0.05); setTimeout(() => tone(300, 0.1, "sine", 0.05), 55); },
  close: () => tone(500, 0.08, "triangle", 0.04),
  alarm: () => { tone(880, 0.14, "sawtooth", 0.05); setTimeout(() => tone(620, 0.2, "sawtooth", 0.05), 150); },
  go: () => { tone(523, 0.08, "square", 0.05); setTimeout(() => tone(784, 0.1, "square", 0.06), 70); setTimeout(() => tone(1046, 0.16, "square", 0.06), 150); },
  win: () => [523, 659, 784, 1046].forEach((f, i) => setTimeout(() => tone(f, 0.16, "sine", 0.05), i * 110)),
  lose: () => [392, 330, 262].forEach((f, i) => setTimeout(() => tone(f, 0.18, "sine", 0.05), i * 130)),
};

export function setMuted(m) {
  muted = m;
  localStorage.setItem("snetch_sound", m ? "off" : "on");
}
export function isMuted() {
  return muted;
}
export function primeAudio() {
  getCtx();
}
